import React from 'react';

import { ia, iaRa } from 'lib/helpers/utility';

import NotFound from 'components/practice/Dashboard/components/NotFound';
import RadioButton from 'components/shared/RadioButton/RadioButton';
import Skeleton from 'components/shared/Skeleton/Skeleton';

const SelectNoteTable = ({
  noteOptions = [],
  scrollableDivRef = null,
  handleScroll = () => {},
  selectedNote = {},
  onNoteSelect = () => {},
  variant = 'upcoming',
  loading = false,
  isFetching = false,
  hasMore
}) => {
  if (loading) return <Skeleton count="5" height={20} />;

  if (!ia(noteOptions))
    return (
      <>
        <NotFound
          icon="illustration-empty-state-default"
          className="h-full p-3"
          description={`Patient doesn't have any ${variant} appointments`}
        />
      </>
    );

  return (
    <div ref={scrollableDivRef} onScroll={handleScroll} className="max-h-56 overflow-y-auto">
      {iaRa(noteOptions).map((item) => {
        const { value, label } = item || {};
        return (
          <div
            key={item?.value}
            data-note-id={item?.value}
            className="grid cursor-pointer grid-cols-[auto,1fr] items-center gap-x-2 py-3 hover:bg-primary-50"
            onClick={() => onNoteSelect(item)}>
            <div>
              <RadioButton
                className="ml-3"
                isSelected={selectedNote?.value === value}
                name="clinical-notes"
                value={value}
                id={`clinical-note-${value}`}
                onChange={() => onNoteSelect(item)}
              />
            </div>
            <p className="overflow-hidden text-ellipsis whitespace-nowrap text-left text-sm font-500">
              {label}
            </p>
          </div>
        );
      })}
      {hasMore && isFetching && <Skeleton count={1} height={20} />}
    </div>
  );
};

export default SelectNoteTable;
